export default __webpack_public_path__ + "static/media/clock.12c3eed7.svg";